module.exports = __webpack_public_path__ + "img/record_box.ae729383.png";